import SpriteSymbol from "../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sms",
  "use": "icon-sms-usage",
  "viewBox": "0 0 28.44 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.44 18\" id=\"icon-sms\">\n  <path id=\"icon-sms_Path_1022\" data-name=\"Path 1022\" d=\"M0,17.324,11.806,0l6,8.258L28.44.3,16.587,18,10.772,9.306Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol